// extracted by mini-css-extract-plugin
module.exports = {"size":"Icon_size__ZBMzH","svg":"Icon_svg__53nzp","stroke":"Icon_stroke__DWOH_","fill":"Icon_fill__QgGAS"};